// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__8WabY","selects":"Documents_selects__2dC7P"};